import { render, staticRenderFns } from "./EMelderComponentEinstellungenMeldungsvorlagen.vue?vue&type=template&id=5caa2e3b&scoped=true"
import script from "./EMelderComponentEinstellungenMeldungsvorlagen.vue?vue&type=script&lang=js"
export * from "./EMelderComponentEinstellungenMeldungsvorlagen.vue?vue&type=script&lang=js"
import style0 from "./EMelderComponentEinstellungenMeldungsvorlagen.vue?vue&type=style&index=0&id=5caa2e3b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5caa2e3b",
  null
  
)

export default component.exports